import { Card, CardContent, CardHeader, Divider } from "@mui/material"
import { FC } from "react"

interface Props {
    title?: string;
    subtitle?: string;
    children?: React.ReactNode;
}

export const HomeCard: FC<Props> = ({ title, subtitle, children }) => {
    return (
        <Card sx={{ boxShadow: 2 }}>
        {title &&
            <CardHeader
                title={title}
                subheader={subtitle}
                titleTypographyProps={{ variant: 'h2', color: 'primary.contrastText' }}
                subheaderTypographyProps={{ variant: 'subtitle1', color: 'primary.contrastText' }}
                sx={{ bgcolor: 'primary.main' }}
            /> 
        }
        <Divider />
        <CardContent>
            {children}
        </CardContent>
        </Card>
    )
}